/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.onboarding.settings.rpc.LegacyUserGuideSettingsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

/**
 * Virtual record for map with known enum keys
 */

export const getSettingsRpc = {
  serviceName: 'com.hubspot.onboarding.settings.rpc.LegacyUserGuideSettingsRpc',
  rpcName: 'getSettings',
  auth: 'app',
  fingerprint: 'u6ay3xBqcA8QLr-9dasAEiFx8m3FD4a3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const patchSettingsRpc = {
  serviceName: 'com.hubspot.onboarding.settings.rpc.LegacyUserGuideSettingsRpc',
  rpcName: 'patchSettings',
  auth: 'app',
  fingerprint: 'zdI7RRJ0ZdqOUe2e_r4XmSFx8m3FD4a3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteSettingByKeyRpc = {
  serviceName: 'com.hubspot.onboarding.settings.rpc.LegacyUserGuideSettingsRpc',
  rpcName: 'deleteSettingByKey',
  auth: 'app',
  fingerprint: '_6Bo0m0cMh2OUe2e_r4XmSFx8m3FD4a3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteSettingByViewAndKeyRpc = {
  serviceName: 'com.hubspot.onboarding.settings.rpc.LegacyUserGuideSettingsRpc',
  rpcName: 'deleteSettingByViewAndKey',
  auth: 'app',
  fingerprint: 'YXAqiFnrniOOUe2e_r4XmSFx8m3FD4a3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteViewRpc = {
  serviceName: 'com.hubspot.onboarding.settings.rpc.LegacyUserGuideSettingsRpc',
  rpcName: 'deleteView',
  auth: 'app',
  fingerprint: 'qA3pboduKaOOUe2e_r4XmSFx8m3FD4a3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};